import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FaTrash as TrashIcon } from 'react-icons/fa';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CustomNumeral from '../../../shared/customNumeral.component';
import { NumeralTypes } from '../../../shared/numeral.component';

import EditableRow from '../editableSubrow.component';
import { negativePercentage } from '../utils/numeral.utils';
import {
  checkHasRightsToModifyRowSelector,
} from '../store/selectors';
import GroupingColumns from '../GroupingColumns.component';

class Subrow extends PureComponent {
  static propTypes = {
    rowData: PropTypes.shape({
      amount: PropTypes.number,
      companyCode: PropTypes.string,
      columnsData: PropTypes.arrayOf(PropTypes.number),
    }),
    fetchReport: PropTypes.func.isRequired,
    showDeletingDriverModal: PropTypes.func.isRequired,
    tagName: PropTypes.string.isRequired,
    closeNewRow: PropTypes.func,
    ibtAmount: PropTypes.number,
    suppressHidingDecimalPlacesForPercentage: PropTypes.bool,
    hideGroupingColumns: PropTypes.bool.isRequired,
    hasRightsToModifyRow: PropTypes.bool.isRequired,
    updateStickyElementsPosition: PropTypes.func.isRequired,
    changeEditableOnParent: PropTypes.func.isRequired,
  };

  static defaultProps = {
    closeNewRow: () => ({}),
  };

  state = {
    isEditable: false,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.isEditable !== this.state.isEditable) {
      this.props.updateStickyElementsPosition();
    }
  };

  toggleEditable = () => {
    const { hasRightsToModifyRow } = this.props;

    if (hasRightsToModifyRow) {
      this.setState(({ isEditable }) => ({ isEditable: !isEditable }));
    }
  };

  closeAndFetchReport = async () => {
    await this.props.fetchReport();
    this.setState(
      { isEditable: false },
      () => {
        this.props.closeNewRow();
      }
    );
  };

  close = () => {
    this.setState(
      { isEditable: false },
      () => {
        this.props.closeNewRow();
      }
    );
  };

  showDeleteModal = e => {
    e.stopPropagation();
    this.props.showDeletingDriverModal({ rowData: this.props.rowData });
  };

  render() {
    const {
      isEditable,
    } = this.state;

    const {
      rowData,
      tagName,
      ibtAmount,
      suppressHidingDecimalPlacesForPercentage,
      hideGroupingColumns,
      hasRightsToModifyRow,
      changeEditableOnParent,
    } = this.props;

    const rowClasses = classNames(
      'col-6', 'description', 'stick-left'
    );

    if (!isEditable && rowData) {
      return (
        <div className="row child-row subrow" onClick={this.toggleEditable}>
          <div className="etr-icon-wrapper stick-left">
            {
              hasRightsToModifyRow
                ? <TrashIcon size={16} className="cell-icon trash-icon" onClick={this.showDeleteModal} />
                : null
            }
          </div>
          <div className={rowClasses}>{rowData.companyCode}</div>
          <div className="col-2 text-right">
            <CustomNumeral type={NumeralTypes.DECIMAL}>{rowData.amount}</CustomNumeral>
          </div>
          <div className="col-2 text-right">
            <CustomNumeral
              additionalClassNames={negativePercentage}
              type={NumeralTypes.PERCENT_4}
              suppressHidingDecimalPlaces={suppressHidingDecimalPlacesForPercentage}
            >
              {(rowData.amount / ibtAmount)}
            </CustomNumeral>
          </div>
          <GroupingColumns
            hideGroupingColumns={hideGroupingColumns}
            columnsData={rowData.columnsData || []}
          />
        </div>
      );
    }
    return <EditableRow
      rowData={rowData}
      tagName={tagName}
      closeAndFetchReport={this.closeAndFetchReport}
      close={this.close}
      changeEditableOnParent={changeEditableOnParent}
    />;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    hasRightsToModifyRow: checkHasRightsToModifyRowSelector(state, ownProps.rowData),
  };
}

export default connect(mapStateToProps)(Subrow);
